import React from 'react'
import { render } from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import App from './containers/App'
import reducer from './reducers'

// require('./libs/createjs-2015.11.26.combined')
// require('./animatecc')

// window.requestAnimFrame = (function(){
//
//   return  window.requestAnimationFrame       ||
//     window.webkitRequestAnimationFrame ||
//     window.mozRequestAnimationFrame    ||
//     function( callback ){
//       window.setTimeout(callback, 1000 / 60);
//     };
// })();
//

const store = createStore(reducer)

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/